import styles from "./Pagination.module.scss";
import Link from "next/link";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { blog as blogConfig } from "~/config/blog";

export default function Pagination({ pagination, url }) {
  const start = pagination.limit * pagination.page - pagination.limit + 1;
  const end =
    pagination.pages == pagination.page &&
    pagination.pages % pagination.limit != 0
      ? start - 1 + (pagination.total % pagination.limit)
      : pagination.page * pagination.limit;
  const delta = pagination.pages - pagination.page;

  const Prev = () => {
    if (pagination.page <= 1) return;
    return (
      <li>
        <Link
          title="Previous Page"
          href={url(
            pagination.page <= 1 ? pagination.page : pagination.page - 1
          )}
        >
          <span className={styles["--prev"]}>Previous Page</span>
        </Link>
      </li>
    );
  };

  const Next = () => {
    if (pagination.pages <= pagination.page) return;

    return (
      <li>
        <Link
          title="Next Page"
          href={url(
            pagination.page >= pagination.pages
              ? pagination.page
              : pagination.page + 1
          )}
        >
          <span className={styles["--next"]}>Next Page</span>
        </Link>
      </li>
    );
  };

  const Spacer = () => (
    <li>
      <span>...</span>
    </li>
  );

  return (
    <div className={styles["Pagination"]}>
      <div>
        Showing <em>{start}</em> to <em>{end}</em> of{" "}
        <em>{pagination.total}</em> Results
      </div>
      <div>
        <ul>
          <Prev />
          <li>
            <Link
              href={url(1)}
              className={pagination.page == 1 ? styles["--active"] : ""}
            >
              1
            </Link>
          </li>
          {pagination.page >= 3 && <Spacer />}
          {pagination.page - 1 >= 2 && (
            <li>
              <Link href={url(pagination.page - 1)}>{pagination.page - 1}</Link>
            </li>
          )}
          {pagination.page >= 2 && delta >= 1 && (
            <li>
              <Link
                href={url(pagination.page)}
                className={
                  pagination.page != 1 || pagination.page != pagination.pages
                    ? styles["--active"]
                    : ""
                }
              >
                {pagination.page}
              </Link>
            </li>
          )}
          {delta >= 2 && (
            <li>
              <Link href={url(pagination.page + 1)}>{pagination.page + 1}</Link>
            </li>
          )}
          {delta >= 3 && <Spacer />}
          <li>
            <Link
              href={url(pagination.pages)}
              className={
                pagination.page == pagination.pages ? styles["--active"] : ""
              }
            >
              {pagination.pages}
            </Link>
          </li>
          <Next />
        </ul>
      </div>
    </div>
  );
}

Pagination.propTypes = {
  pagination: PropTypes.object,
  url: PropTypes.func,
};

Pagination.defaultProps = {
  pagination: {},
  url: (page) => {
    return `${blogConfig.baseUrl}page/${page}`;
  },
};
